import React from 'react';

const CBProgress = ({
  percent = 0,
  status, // 'success', 'exception', 'normal', 'active' (active implies normal + animation)
  type = 'line', // 'line', 'circle'
  showInfo = true, // Show percentage text
  strokeColor, // Custom color
  trailColor, // Color of the trail
  format = (percent) => `${percent}%`, // Formatter for text
  className = '',
  // Circle specific props
  width = 120, // Width of the circle canvas
  strokeWidth = 6, // Width of the progress stroke
}) => {
  const isNormal = status === 'normal' || status === 'active' || !status;
  const isSuccess = status === 'success';
  const isException = status === 'exception';
  const isActive = status === 'active'; // For potential animation

  let colorClass = 'bg-blue-500'; // Default normal/active
  if (isSuccess) colorClass = 'bg-green-500';
  if (isException) colorClass = 'bg-red-500';

  const trailColorClass = trailColor || 'bg-gray-200';

  const safePercent = Math.max(0, Math.min(100, percent));

  if (type === 'circle') {
    const radius = (width / 2) - (strokeWidth / 2);
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (safePercent / 100) * circumference;

    let strokeColorClass = 'text-blue-500'; // Default normal/active
    if (isSuccess) strokeColorClass = 'text-green-500';
    if (isException) strokeColorClass = 'text-red-500';
    if (strokeColor) strokeColorClass = strokeColor; // Allow override

    const trailStrokeClass = trailColor || 'text-gray-200';

    return (
      <div className={`relative inline-block ${className}`} style={{ width, height: width }}>
        <svg className="transform -rotate-90" width={width} height={width} viewBox={`0 0 ${width} ${width}`}>
          <circle
            className={`stroke-current ${trailStrokeClass}`}
            strokeWidth={strokeWidth}
            fill="transparent"
            r={radius}
            cx={width / 2}
            cy={width / 2}
          />
          <circle
            className={`stroke-current ${strokeColorClass} transition-stroke-dashoffset duration-300 ease-linear`}
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            fill="transparent"
            r={radius}
            cx={width / 2}
            cy={width / 2}
          />
        </svg>
        {showInfo && (
          <div className="absolute inset-0 flex items-center justify-center text-xs font-medium">
            {format(safePercent)}
          </div>
        )}
      </div>
    );
  }

  // Line type
  return (
    <div className={`w-full ${className}`}>
      <div className={`relative h-2 rounded-full overflow-hidden ${trailColorClass}`}>
        <div
          className={`absolute top-0 left-0 h-full rounded-full ${colorClass} ${isActive ? 'animate-pulse' : ''} transition-width duration-300 ease-linear`}
          style={{ width: `${safePercent}%` }}
        ></div>
      </div>
      {showInfo && (
        <div className="text-sm text-center mt-1">
          {format(safePercent)}
        </div>
      )}
    </div>
  );
};

export { CBProgress };